<div class="container agency-request-form">
  <div class="row">
    <h5 class="header-tab mt-3" *ngIf="pageTitle">
      {{ pageTitle }}
    </h5>
    <div class="form-row">
      <div class="col-sm-8">
        <p>
          {{ pageDescription }}
        </p>
      </div>
    </div>

    <div>
      <form
        [formGroup]="frmGroup"
        id="agency-request"
        (ngSubmit)="saveAgencyRequest($event, form)"
        #form="ngForm"
        [action]="agencyRequestUrl?.fieldInfo.fieldValue"
        method="POST"
      >
        <input
          type="hidden"
          [name]="oid?.fieldInfo.fieldName"
          [value]="oid?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [name]="agencyRequestUrl?.fieldInfo.fieldName"
          [value]="agencyRequestReturnUrl"
        />
        <input
          type="hidden"
          [name]="lead_source?.fieldInfo.fieldName"
          [value]="lead_source?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [name]="debug?.fieldInfo.fieldName"
          [value]="debug?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [name]="debugEmail?.fieldInfo.fieldName"
          [value]="debugEmail?.fieldInfo.fieldValue"
        />
        <!-- <input
          type="hidden"
          [id]="upn?.fieldInfo.fieldName"
          [name]="upn?.fieldInfo.fieldID"
        /> -->
        <input
          type="hidden"
          [id]="aor?.fieldInfo.fieldName"
          [name]="aor?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="first_name?.fieldInfo.fieldName"
          [name]="first_name?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="last_name?.fieldInfo.fieldName"
          [name]="last_name?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="agency_name?.fieldInfo.fieldName"
          [name]="agency_name?.fieldInfo.fieldID"
          [value]="agency_name?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [id]="office_address?.fieldInfo.fieldName"
          [name]="office_address?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="city?.fieldInfo.fieldName"
          [name]="city?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="state?.fieldInfo.fieldName"
          [name]="state?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="zip?.fieldInfo.fieldName"
          [name]="zip?.fieldInfo.fieldID"
        />
        <!-- <input
          type="hidden"
          [id]="office_country?.fieldInfo.fieldName"
          [name]="office_country?.fieldInfo.fieldID"
        /> -->
        <input
          type="hidden"
          [id]="phone?.fieldInfo.fieldName"
          [name]="phone?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="email?.fieldInfo.fieldName"
          [name]="email?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="ParentLicenseType?.fieldInfo.fieldName"
          [name]="ParentLicenseType?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="LicenseNumber?.fieldInfo.fieldName"
          [name]="LicenseNumber?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="license_expiration_date?.fieldInfo.fieldName"
          [name]="license_expiration_date?.fieldInfo.fieldID"
        />
        <div class="form-row">
          <div
            class="col-sm-12 agency-form"
            *ngFor="let items of agencyRequestField"
          >
            <div class="col-sm-8">
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
          </div>
          <div
            class="col-sm-12 agency-form"
            *ngFor="let items of phoneRequestField"
          >
            <div class="col-sm-8">
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
          </div>
          <div
            class="col-sm-12 agency-form"
            *ngFor="let items of emailRequestField"
          >
            <div class="col-sm-8">
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
          </div>
        </div>
        <div>
          <label class="mr-5">
            {{ requestFormLabel.agencyRequestLabel }}
          </label>
          <div class="form-row col-sm-8 p-l-0" *ngIf="checkboxFlag">
            <div
              class="productField"
              *ngFor="let items of agencyRequestProduct"
            >
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
          </div>
        </div>
        <div>
          <label class="mr-5  mt-3">
            {{ requestFormLabel.companyRequestLabel }}
          </label>
          <div class="form-row m-r-10">
            <div class="col-sm-8" *ngFor="let items of companyRequestField">
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
          </div>
        </div>
        <div>
          <!-- <label class="mr-5">
            {{ requestFormLabel.premiumProductLabel
            }}<span class="required-star">*</span>
          </label> -->
          <div class="form-row col-sm-7 p-all-0">
            <div *ngFor="let items of premiumProduct">
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
            <!-- <div
              class="alert alert-warning"
              *ngIf="hasFormBeenSubmitted && !radioSelected"
            >
              Premium is required
            </div> -->
          </div>
        </div>
        <div class="form-row">
          <div class="button-row agency-btn" style="float:left">
            <button type="submit" class="btn btn-primary">
              {{ buttonLabel }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
